import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { Breadcrumb } from '@quicktools/shared-components';

import { isMobile } from '../../configs';
import PDFView from '../PDFView';
import analytics from '../../services/analytics';
import { useStore } from '../../store';
import { ExportStatusEnum } from '../../store/types';
import { CombinatedColorsEnum } from '../../types';
import { changeColorBrightness } from '../../utils/common/changeColorBrightness';

import useStyles from './styles';

const ColorComponent = dynamic(() => import('../../components/ColorComponent'), {
  loading: () => null,
});

const BREADCRUMBS = [
  {
    text: 'Home',
    href: '/',
  },
  {
    text: 'Color',
    href: '/color',
  },
  {
    text: 'Wheel',
    href: '',
  },
];

const Main = () => {
  const {
    state: { mainColorCombination, exportStatus },
  } = useStore();
  const mainColor = mainColorCombination[CombinatedColorsEnum.MAIN_COLOR];
  const color = changeColorBrightness(mainColor.color, mainColor.brightness).hex().toString();

  const styles = useStyles({ isMobile, BGColor: color });

  useEffect(() => {
    analytics.sendEvent('page_open', {
      page_name: 'color_wheel',
      non_interaction: true,
    });
  }, []);

  return (
    <>
      <div>
        <div className={styles.header}>
          <Breadcrumb className={styles.breadcrumb} whiteText items={BREADCRUMBS} />
          <h1 className={styles.title}>Color wheel</h1>
          <p className={styles.description}>
            Combine colors in multiple ways using Picsarts color wheel. Use the color weel to select
            a primary color and see what combinations look best.
          </p>
        </div>
        <div className={styles.footer}></div>
      </div>

      <div className={styles.wrapper}>
        <div className={styles.container}>
          <ColorComponent />
        </div>
      </div>

      {exportStatus === ExportStatusEnum.STARTED && <PDFView />}
    </>
  );
};

export default Main;
